import type { ReactElement } from 'react';
import { Badge } from '@eventbrite/marmalade';
import { type BadgeInfo } from './badgeInfo';
import { useIntl } from 'react-intl';
import styles from './UrgencySignalBadge.module.scss';

interface Props {
  badge: BadgeInfo;
}

export const UrgencySignalBadge: React.FC<Props> = ({ badge }) => {
  const { formatMessage } = useIntl();
  return (
    <Badge variant={badge.style} bordered={true} className={styles.badge} icon={badge.icon as ReactElement}>
      {formatMessage(badge.text)}
    </Badge>
  );
};
